import axios from 'axios';
import pako from "pako";
import { rewriteLegacyDeliCosUrl } from '@/utils/cosUrl';
export default {
    getBaseURL: function () {
        if (window.require) {
            return window.vue.$call.sendSync("apiConfig.baseURL");
        }
        return (process.env.NODE_ENV == "development" ? "http://127.0.0.1:3344" : "https://dy-sh.deli7788.cn");
    },
    getUserInfo: function () {
        var s = localStorage.getItem("user-info");
        if (s) {
            return JSON.parse(s);
        }
        if (window.require) {
            return window.vue.$call.sendSync("session.getUser");
        }
        return;
    },
    getService: function () {
        let baseUrl = this.getBaseURL();
        // console.log("baseUrl",baseUrl);
        // console.log("window.require",window.require);
        return axios.create({
            baseURL: baseUrl, // api的base_url
            timeout: 600000,                 // 请求超时时间
            withCredentials: true,		//携带cookie
            headers: { 'x-Requested-With': 'xmlhttprequest' }, //ajax请求
        });
    },
    postGzip: function (url, parameter, headers, config) {
        var user = this.getUserInfo();
        if (headers === undefined) {
            headers = {};
        }
        if (config === undefined) {
            config = {};
        }
        if (user) {
            headers.Token = user.mtk;
            headers.SToken = user.stk;
        }
        headers["Content-Type"] = "application/json";
        headers["Content-Encoding"] = "gzip";
        user = null;
        const jsonStr = typeof parameter === "string" ? parameter : JSON.stringify(parameter);
        return this.getService()({
            url: url,
            method: 'post',
            data: pako.gzip(jsonStr),
            headers: headers,
            ...config,
        }).then(rs => {
            if (rs.status == 200) {
                return rewriteLegacyDeliCosUrl(rs.data);
            } else {
                return { code: -1, err: "请求数据异常pgzip" }
            }
        }).catch((e) => {
            console.log("@@@@@@@@@@@@@postGzip", e)
            return { code: -1, err: "请求数据异常pgzip err" }
        })
    },
    post: function (url, parameter, headers) {
        var user = this.getUserInfo();
        if (headers === undefined) {
            headers = {};
        }
        if (user) {
            headers.Token = user.mtk;
            headers.SToken = user.stk;
        }
        user = null;
        return this.getService()({
            url: url,
            method: 'post',
            data: parameter,
            headers: headers
        }).then(rs => {
            if (rs.status == 200) {
                return rewriteLegacyDeliCosUrl(rs.data);
            } else {
                return { code: -1, err: "请求数据异常 post" }
            }
        }).catch((e) => {
            console.log("@@@@@@@@@@@@@post", e)
            return { code: -1, err: "请求数据异常 post err" }
        })
    }
}
